import { configureStore } from '@reduxjs/toolkit'
import { localStorageMiddleware } from './middleware'
import commonReducer from '../reducers/common'
import userReducer from '../reducers/admin-user/user'
import signInFormReducer from '../reducers/admin-user/sign-in-form'
import forgotPasswordFormReducer from '../reducers/admin-user/forgot-password-form'
import userGeneralSettingsFormReducer from '../reducers/admin-user/user-general-settings-form'
import meetingListReducer from '../reducers/meetings/meeting-list'
import meetingTypeListReducer from '../reducers/meetings/types/type-list'
import meetingTypeCreateReducer from '../reducers/meetings/types/create'
import meetingTypeUpdateReducer from '../reducers/meetings/types/update'
import meetingTypeDetailsReducer from '../reducers/meetings/types/details'
import meetingTypeTagCreateReducer from '../reducers/meetings/types/tags/create'
import meetingTypeTagUpdateReducer from '../reducers/meetings/types/tags/update'
import userListReducer from '../reducers/users/user-list'
import userStatisticReducer from '../reducers/users/user-statistic'

export function makeStore(preloadedState) {
  return configureStore({
    reducer: {
      common: commonReducer,
      // Admin user
      adminUser: userReducer,
      adminSignInForm: signInFormReducer,
      adminForgotPasswordForm: forgotPasswordFormReducer,
      adminUserGeneralSettingsForm: userGeneralSettingsFormReducer,
      // Meeting
      meetingList: meetingListReducer,
      meetingTypeList: meetingTypeListReducer,
      meetingTypeCreate: meetingTypeCreateReducer,
      meetingTypeUpdate: meetingTypeUpdateReducer,
      meetingTypeDetails: meetingTypeDetailsReducer,
      meetingTypeTagCreate: meetingTypeTagCreateReducer,
      meetingTypeTagUpdate: meetingTypeTagUpdateReducer,
      // Users
      userList: userListReducer,
      userStatistic: userStatisticReducer,
    },
    devTools: true,
    preloadedState,
    middleware: (getDefaultMiddleware) => [...getDefaultMiddleware(), localStorageMiddleware],
  })
}

const store = makeStore()

export default store
